import React, { useEffect, useState } from 'react';
import styles from '@/components/IntegrationExport/LocalExcelCard/styles';
import { TextField, Button, CircularProgress } from '@material-ui/core';
import { adminChangeXlsUrlAutobook, SaveApiResMessage } from '@/actions';

export default ({ state, excelConfigData }) => {
  const [loadingForm, setLoadingForm] = useState(false);
  const [url, setUrl] = useState('');
  const [tmsAlias, setTmsAlias] = useState('');
  const cls = styles();

  const handleChangeXlsUrl = () => {
    setLoadingForm(true);
    let data = {
      user_id: state.DATA.id,
      xls_url_autobook: url,
    };
    if (tmsAlias) {
      data.tms_manual_alias = tmsAlias;
    }
    adminChangeXlsUrlAutobook(data)
      .then((data) => {
        setLoadingForm(false);
        SaveApiResMessage({
          title: data?.data?.messageHeader,
          message: 'successfully updated',
          mode: 'success',
        });
      })
      .catch((err) => {
        SaveApiResMessage({ title: 'Error', message: err, mode: 'warning' });
        setLoadingForm(false);
      });
  };

  useEffect(() => {
    const configSource = excelConfigData || state.DATA;
    setUrl(state.DATA?.excel_config_autobook_data?.xls_url || '');
    setTmsAlias(configSource.tms_manual_alias || '');
  }, [state, excelConfigData]);

  return (
    <div className={cls.card}>
      {state.loading ? (
        <div className={cls.loaderContainer}>
          <CircularProgress className={cls.loader} />
        </div>
      ) : (
        <>
          <div className={cls.urlContainer}>
            <span>Excel URL:</span>
            <TextField
              type="url"
              placeholder="Excel URL:"
              className={cls.input}
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              InputProps={{ disableUnderline: true }}
              inputProps={{ min: 0 }}
            />
          </div>
          <div style={{ marginTop: '20px' }}>
            <div className={cls.optionContainer}>
              <span>TMS Alias:</span>
            </div>
            <div className={cls.urlContainer}>
              <TextField
                type="text"
                placeholder="TMS Alias"
                className={cls.input}
                InputProps={{ disableUnderline: true }}
                value={tmsAlias}
                onChange={(e) => setTmsAlias(e.target.value)}
              />
            </div>
          </div>
          <div className={cls.actions}>
            {loadingForm ? (
              <div className={cls.loaderContainer}>
                <CircularProgress className={cls.loader} />
              </div>
            ) : (
              <div className={cls.btnContainer}>
                <Button
                  disabled={Object.keys(state.DATA).length < 0 ? true : false}
                  onClick={() => handleChangeXlsUrl()}>
                  Save
                </Button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
